import { Language } from "@/data/model/Enums";

import { clientLanguage } from "@/shared/localization/language";

export let trans_vue: {
    addToCartPopover: {
        adding: string;
        price: string;
    };
    bill: {
        fullyPaidItems: string;
        noOrderYet: string;
    };
    billSection: {
        noPaymentServiceConfigured: string;
    };
    cart: {
        failedToAdd: string;
        failedToChange: string;
        haveItemsInCart: string;
        notAbleToPrepareForCheckout: string;
        order: string;
        paymentBlockingCart: string;
    };
    cartItemsList: {
        cart: string;
    };
    messages: {
        deviceNotFoundPleaseRefresh: string;
        unauthorizedPleaseRefresh: string;
    };
    offerSection: {
        noOrderServiceConfigured: string;
    };
    orderAndPayView: {
        failedLoadingBill: string;
        failedLoadingOffer: string;
        failedToAllocateToTable: string;
        pleaseSelectAnotherTable: string;
        tableNotActive: string;
    };
    paymentMethodSelector: {
        noPaymentMethodConfigured: string;
    };
};

const setEnglish = () => {
    trans_vue = {
        addToCartPopover: {
            adding: "...",
            price: "Price",
        },
        bill: {
            fullyPaidItems: "Fully Paid Items",
            noOrderYet: "Everything is paid, thank you!",
        },
        billSection: {
            noPaymentServiceConfigured: "No Payment Service configured",
        },
        cart: {
            failedToAdd: "Item could not be added.",
            failedToChange: "Item could not be modified.",
            haveItemsInCart: "You have items in your {0} cart. If you continue, your cart will be deleted.",
            notAbleToPrepareForCheckout: "Cart could not be prepared for payment.",
            order: "Order",
            paymentBlockingCart: "The cart cannot be adjusted while a payment is in progress.",
        },
        cartItemsList: {
            cart: "Cart",
        },
        messages: {
            deviceNotFoundPleaseRefresh: "Device not found. The page will reload, please sign in again.",
            unauthorizedPleaseRefresh: "Your session has expired. The page will reload, please try again.",
        },
        offerSection: {
            noOrderServiceConfigured: "No Order Service configured",
        },
        orderAndPayView: {
            failedLoadingBill: "Failed to load bill",
            failedLoadingOffer: "Failed to load offer.",
            failedToAllocateToTable: "Check-in failed",
            pleaseSelectAnotherTable: "Please select another table or activate the table / room and try again.",
            tableNotActive: "This table / room is currently not activated.",
        },
        paymentMethodSelector: {
            noPaymentMethodConfigured: "No payment method configured",
        },
    };
};

const setGerman = () => {
    trans_vue = {
        addToCartPopover: {
            adding: "...",
            price: "Preis",
        },
        bill: {
            fullyPaidItems: "Vollständig Bezahlte Artikel",
            noOrderYet: "Alles ist bezahlt, danke!",
        },
        billSection: {
            noPaymentServiceConfigured: "Kein Zahlungsdienst konfiguriert",
        },
        cart: {
            failedToAdd: "Artikel konnte nicht hinzugefügt werden.",
            failedToChange: "Artikel konnte nicht modifiziert werden.",
            haveItemsInCart: "Du hast Artikel in deinem {0} Warenkorb. Wenn du fortfährst, wird dein Warenkorb gelöscht.",
            notAbleToPrepareForCheckout: "Warenkorb konnte nicht für die Zahlung vorbereitet werden.",
            order: "Bestellen",
            paymentBlockingCart: "Der Warenkorb kann nicht angepasst werden während eine Zahlung in Bearbeitung ist.",
        },
        cartItemsList: {
            cart: "Warenkorb",
        },
        messages: {
            deviceNotFoundPleaseRefresh: "Gerät nicht gefunden. Die Seite wird neu geladen, bitte loggen Sie sich erneut ein.",
            unauthorizedPleaseRefresh: "Deine Sitzung ist abgelaufen. Die Seite wird neu geladen, bitte versuche es nochmals.",
        },
        offerSection: {
            noOrderServiceConfigured: "Kein Bestellservice konfiguriert",
        },
        orderAndPayView: {
            failedLoadingBill: "Rechnung konnte nicht geladen werden",
            failedLoadingOffer: "Das Angebot konnte nicht geladen werden.",
            failedToAllocateToTable: "Einchecken fehlgeschlagen",
            pleaseSelectAnotherTable: "Bitte einen anderen Tisch wählen oder den Tisch / Raum aktivieren und erneut versuchen.",
            tableNotActive: "Dieser Tisch / Raum ist derzeit nicht aktiviert.",
        },
        paymentMethodSelector: {
            noPaymentMethodConfigured: "Kein Zahlungsmittel konfiguriert",
        },
    };
};

const setFrench = () => {
    trans_vue = {
        addToCartPopover: {
            adding: "...",
            price: "Prix",
        },
        bill: {
            fullyPaidItems: "Articles Payés Intégralement",
            noOrderYet: "Tout est payé, merci!",
        },
        billSection: {
            noPaymentServiceConfigured: "Pas de service de paiement configuré",
        },
        cart: {
            failedToAdd: "L'article n'a pas pu être ajouté.",
            failedToChange: "L'article n'a pas pu être modifié.",
            haveItemsInCart: "Tu as des articles dans ton panier {0}. Si tu continues, ton panier sera supprimé.",
            notAbleToPrepareForCheckout: "Le panier n'a pas pu être préparé pour le paiement.",
            order: "Commander",
            paymentBlockingCart: "Le panier ne peut pas être modifié pendant qu'un paiement est en cours.",
        },
        cartItemsList: {
            cart: "Panier",
        },
        messages: {
            deviceNotFoundPleaseRefresh: "Appareil non trouvé. La page va se recharger, veuillez vous connecter à nouveau.",
            unauthorizedPleaseRefresh: "Ta session a expiré. La page va se recharger, merci de réessayer.",
        },
        offerSection: {
            noOrderServiceConfigured: "Pas de Service de Commande configuré",
        },
        orderAndPayView: {
            failedLoadingBill: "Échec du chargement de la facture",
            failedLoadingOffer: "Échec du chargement de l'offre.",
            failedToAllocateToTable: "Check-in échoué",
            pleaseSelectAnotherTable: "Veuillez choisir une autre table ou activer la table / salle et réessayer.",
            tableNotActive: "Cette table / salle n'est actuellement pas activée.",
        },
        paymentMethodSelector: {
            noPaymentMethodConfigured: "Aucun moyen de paiement configuré",
        },
    };
};

const setItalian = () => {
    trans_vue = {
        addToCartPopover: {
            adding: "...",
            price: "Prezzo",
        },
        bill: {
            fullyPaidItems: "Articoli Completamente Pagati",
            noOrderYet: "Tutto è pagato, grazie!",
        },
        billSection: {
            noPaymentServiceConfigured: "Nessun Servizio di Pagamento configurato",
        },
        cart: {
            failedToAdd: "L'articolo non può essere aggiunto.",
            failedToChange: "L'articolo non può essere modificato.",
            haveItemsInCart: "Hai articoli nel tuo carrello di {0}. Se continui, il tuo carrello verrà cancellato.",
            notAbleToPrepareForCheckout: "Il carrello non poteva essere preparato per il pagamento.",
            order: "Ordinare",
            paymentBlockingCart: "Il carrello non può essere modificato mentre un pagamento è in corso.",
        },
        cartItemsList: {
            cart: "Carrello",
        },
        messages: {
            deviceNotFoundPleaseRefresh: "Dispositivo non trovato. La pagina verrà ricaricata, si prega di accedere nuovamente.",
            unauthorizedPleaseRefresh: "La tua sessione è finita. La pagina si ricaricherà, si prega di riprovare.",
        },
        offerSection: {
            noOrderServiceConfigured: "Nessun Servizio d'Ordine configurato",
        },
        orderAndPayView: {
            failedLoadingBill: "Impossibile caricare la fattura",
            failedLoadingOffer: "Impossibile caricare l'offerta.",
            failedToAllocateToTable: "Check-in fallito",
            pleaseSelectAnotherTable: "Selezionare un altro tavolo o attivare il tavolo / la sala e riprovare.",
            tableNotActive: "Questo/a tavolo / sala non è attualmente attivato/a.",
        },
        paymentMethodSelector: {
            noPaymentMethodConfigured: "Nessun mezzo di pagamento configurato",
        },
    };
};

switch (clientLanguage()) {
    case Language.English:
        setEnglish();
        break;
    case Language.German:
        setGerman();
        break;
    case Language.French:
        setFrench();
        break;
    case Language.Italian:
        setItalian();
        break;
    default:
        setEnglish();
        break;
}
